/* Mobile gestures: keep vertical scrolling/zoom, suppress only swipe clicks. */
window.mgBindMobileSwipe = window.mgBindMobileSwipe || function(surface, move, start, end) {
  if (!surface || surface.dataset.mgSwipeBound) return;
  surface.dataset.mgSwipeBound = '1';
  var gesture = null, blockedUntil = 0;
  function finish() { gesture = null; if (end) end(); }
  surface.addEventListener('touchstart', function(e) {
    if (!matchMedia('(max-width:900px)').matches || e.touches.length !== 1 || e.target.closest('button,input,textarea,select,details')) { finish(); return; }
    var p = e.touches[0]; gesture = { id:p.identifier, x:p.clientX, y:p.clientY, axis:null };
    if (start) start();
  }, {passive:true});
  surface.addEventListener('touchmove', function(e) {
    if (!gesture) return;
    if (e.touches.length !== 1) { finish(); return; }
    var p = e.touches[0], dx = p.clientX-gesture.x, dy = p.clientY-gesture.y;
    if (!gesture.axis && Math.max(Math.abs(dx),Math.abs(dy)) > 10) gesture.axis = Math.abs(dx)>Math.abs(dy)*1.4 ? 'x' : 'y';
    if (gesture.axis === 'x') { if(e.cancelable) e.preventDefault(); blockedUntil=Date.now()+500; }
  }, {passive:false});
  surface.addEventListener('touchend', function(e) {
    if (!gesture) return;
    var g=gesture, p=[].find.call(e.changedTouches,function(t){return t.identifier===g.id;});
    if (!p) return;
    var dx=p.clientX-g.x, dy=p.clientY-g.y;
    if (g.axis !== 'y' && Math.abs(dx)>=40 && Math.abs(dx)>Math.abs(dy)*1.4) { blockedUntil=Date.now()+500; move(dx<0?1:-1); }
    finish();
  }, {passive:true});
  surface.addEventListener('touchcancel',finish,{passive:true});
  surface.addEventListener('click',function(e){if(Date.now()<blockedUntil){e.preventDefault();e.stopImmediatePropagation();}},true);
};
/* Memorigin scripts: run once per page, whatever else asks for them. */
if (!window.__mgSupplyLoaded) { window.__mgSupplyLoaded = 1;
/* Memorigin homepage motion: masked reveals + tweened glide (IWC's easing: cubic-bezier(.2,0,0,1)) */
(function () {
  var reduce = !window.matchMedia || matchMedia('(prefers-reduced-motion: reduce)').matches;
  var capable = 'IntersectionObserver' in window && 'requestAnimationFrame' in window && 'classList' in document.documentElement;
  /* the hidden-before-reveal styles only apply once this class is set, so the page still
     renders in full if this script never runs (blocked, cached out, old browser) */
  if (!reduce && capable) document.documentElement.className += ' mg-js';

  function reveal(root) {
    var els = [].slice.call((root || document).querySelectorAll('.mgx .rv'));
    if (!els.length) return;
    function show(el) {
      if (el.classList.contains('in')) return;
      el.classList.add('in');
      if (el.classList.contains('zoom')) {
        var img = el.querySelector('img');
        if (img) img.addEventListener('animationend', function () { el.classList.add('settled'); }, { once: true });
        else el.classList.add('settled');
      }
    }
    if (reduce || !capable) {
      els.forEach(function (e) { e.classList.add('in', 'settled'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });
    els.forEach(function (e) { io.observe(e); });
    function sweep() {
      // Read the pending positions together before changing reveal classes.
      var visible = els.filter(function (e) {
        return !e.classList.contains('in') && e.getBoundingClientRect().top < innerHeight * 0.92;
      });
      visible.forEach(function (e) { show(e); io.unobserve(e); });
    }
    setTimeout(function () { els.forEach(show); }, 3000); /* failsafe: never leave content hidden */
    var sweepQueued = false;
    function queueSweep() {
      if (sweepQueued) return;
      sweepQueued = true;
      requestAnimationFrame(function () { sweepQueued = false; sweep(); });
    }
    addEventListener('scroll', queueSweep, { passive: true });
    addEventListener('resize', queueSweep);
    sweep();
  }

  function bezier(p1x, p1y, p2x, p2y) {
    function A(a, b) { return 1 - 3 * b + 3 * a; }
    function B(a, b) { return 3 * b - 6 * a; }
    function C(a) { return 3 * a; }
    function calc(t, a, b) { return ((A(a, b) * t + B(a, b)) * t + C(a)) * t; }
    function slope(t, a, b) { return 3 * A(a, b) * t * t + 2 * B(a, b) * t + C(a); }
    return function (x) {
      var t = x, i, s;
      for (i = 0; i < 6; i++) { s = slope(t, p1x, p2x); if (!s) break; t -= (calc(t, p1x, p2x) - x) / s; }
      return calc(t, p1y, p2y);
    };
  }
  var ease = bezier(0.2, 0, 0, 1);

  function glide(section) {
    if (section.getAttribute('data-mg-glide-built')) return;
    section.setAttribute('data-mg-glide-built', '1');
    var track = section.querySelector('.glide'),
        clip = section.querySelector('.glide-clip'),
        prev = section.querySelector('[data-mg-prev]'),
        next = section.querySelector('[data-mg-next]'),
        noEl = section.querySelector('[data-mg-gno]'),
        bar = section.querySelector('[data-mg-gbar]'),
        cards = track ? [].slice.call(track.querySelectorAll('.card')) : [];
    var n = cards.length;
    if (!track || !n) return;
    cards.forEach(function (c, i) { c.setAttribute('data-k', i); });
    
    /* Seamless repeat: duplicate cards on desktop so the row has at least 12 cards and never shows empty space */
    if (!isPhone() && n > 1) {
      while (track.querySelectorAll('.card').length < 12) {
        cards.forEach(function (c, i) {
          var copy = c.cloneNode(true);
          copy.setAttribute('data-k', i);
          copy.setAttribute('data-clone', '1');
          copy.setAttribute('tabindex', '-1');
          copy.setAttribute('aria-hidden', 'true');
          copy.classList.remove('lead');
          var img = copy.querySelector('img');
          if (img) img.setAttribute('loading', 'lazy');
          track.appendChild(copy);
        });
      }
    }
    var busy = false;

    function isPhone() { return false; } /* back to auto-rotating on phone too, like before the static-grid pass */
    function pad(i) { return (i < 9 ? '0' : '') + (i + 1); }
    function first() { return track.querySelector('.card'); }
    function count() {
      var f = first(), i = f ? +f.getAttribute('data-k') : 0;
      if (isPhone() && clip) {
        var w = f ? f.getBoundingClientRect().width : 1;
        i = clip.scrollLeft + clip.clientWidth >= clip.scrollWidth - 4 ? n - 1 : Math.round(clip.scrollLeft / w);
        i = Math.max(0, Math.min(n - 1, i));
      }
      if (noEl) noEl.textContent = (i < 9 ? '0' : '') + (i + 1);
      if (bar) bar.style.width = ((i + 1) / n * 100) + '%';
    }
    function narrow() {
      var w = 0;
      [].forEach.call(track.children, function (c) { if (c.classList.contains('card') && !c.classList.contains('lead')) w = c.getBoundingClientRect().width; });
      return w;
    }
    function lead() {
      var f = first();
      [].forEach.call(track.querySelectorAll('.card'), function (c) { c.classList.toggle('lead', c === f && !isPhone()); });
    }
    /* hold the row's height while cards swap size, so the page below never jumps */
    var holdT = null, tallest = 0;
    function hold() {
      clearTimeout(holdT);
      tallest = Math.max(tallest, Number(track.dataset.mgStableHeight)||0, track.getBoundingClientRect().height);
      track.style.minHeight = tallest + 'px';
      holdT = setTimeout(function () {
        track.style.minHeight = (track.dataset.mgStableHeight||'0') + 'px';
        tallest = Math.max(tallest, track.getBoundingClientRect().height);
        track.style.minHeight = tallest + 'px';
      }, 1100);
    }
    function still(fn) { section.classList.add('no-anim'); fn(); void track.offsetWidth; section.classList.remove('no-anim'); }
    function go(dir) {
      if (busy || n < 2) return;
      if (isPhone()) {
        if (!clip) return;
        var c = cards[0], cw = c ? c.getBoundingClientRect().width : clip.clientWidth;
        if (dir > 0 && clip.scrollLeft + clip.clientWidth >= clip.scrollWidth - 4) clip.scrollTo({ left: 0, behavior: 'smooth' });
        else clip.scrollBy({ left: dir * cw, behavior: 'smooth' });
        return;
      }
      busy = true; hold();
      if (dir > 0) {
        var w = narrow(), out = first();
        var nx = out.nextElementSibling;
        [].forEach.call(track.querySelectorAll('.card'), function (c) { c.classList.toggle('lead', c === nx); });
        count2(nx);
        track.style.transform = 'translate3d(' + (-w) + 'px,0,0)';
        setTimeout(function () {
          still(function () { track.appendChild(out); track.style.transform = ''; });
          out.classList.add('is-back'); setTimeout(function () { out.classList.remove('is-back'); }, 20);
          busy = false;
        }, 980);
      } else {
        var last = track.lastElementChild;
        still(function () {
          track.insertBefore(last, first());
          track.style.transform = 'translate3d(' + (-narrow()) + 'px,0,0)';
        });
        requestAnimationFrame(function () {
          lead(); count();
          track.style.transform = '';
          setTimeout(function () { busy = false; }, 980);
        });
      }
    }
    function count2(c) {
      var i = c ? +c.getAttribute('data-k') : 0;
      if (noEl) noEl.textContent = (i < 9 ? '0' : '') + (i + 1);
      if (bar) bar.style.width = ((i + 1) / n * 100) + '%';
    }
    if (prev) { prev.addEventListener('click', function () { go(-1); restartAuto(); }); }
    if (next) { next.addEventListener('click', function () { go(1); restartAuto(); }); }
    if (clip) clip.addEventListener('scroll', function () { if (isPhone()) count(); }, { passive: true });
    /* the row moves on by itself every seven seconds on desktop only */
    var autoT = null;
    function tick() { if (!document.hidden && !isPhone()) go(1); }
    function restartAuto() { clearInterval(autoT); if (!isPhone()) { autoT = setInterval(tick, 7000); } }
    window.mgBindMobileSwipe(clip, function(dir){go(dir);}, function(){clearInterval(autoT);}, restartAuto);
    restartAuto();
    var carouselViewportWidth = window.innerWidth;
    addEventListener('resize', function () {
      if (window.innerWidth === carouselViewportWidth) return;
      carouselViewportWidth = window.innerWidth;
      tallest = 0; track.style.minHeight = '';
      if (isPhone()) {
        track.querySelectorAll('.card[data-clone="1"]').forEach(function (c) { c.remove(); });
        cards.forEach(function (c) { track.appendChild(c); });
      } else if (n > 1) {
        while (track.querySelectorAll('.card').length < 12) {
          cards.forEach(function (c, i) {
            var copy = c.cloneNode(true);
            copy.setAttribute('data-k', i);
            copy.setAttribute('data-clone', '1');
            copy.setAttribute('tabindex', '-1');
            copy.setAttribute('aria-hidden', 'true');
            copy.classList.remove('lead');
            var img = copy.querySelector('img');
            if (img) img.setAttribute('loading', 'lazy');
            track.appendChild(copy);
          });
        }
      }
      still(function () { track.style.transform = ''; lead(); }); count();
      restartAuto();
    });
    still(function () { lead(); }); count();
  }

  function init(root) {
    reveal(root);
    [].slice.call((root || document).querySelectorAll('[data-mg-glide]')).forEach(glide);
  }

  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });

  /* theme editor: re-run when a section is redrawn */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ---- Memorigin selected: an endless row that advances on its own ---- */
(function () {
  var reduce = !window.matchMedia || matchMedia('(prefers-reduced-motion: reduce)').matches;
  function build(section) {
    if (section.getAttribute('data-mg-built')) return;
    section.setAttribute('data-mg-built', '1');
    var rail = section.querySelector('.frail');
    if (!rail) return;
    var track = rail.querySelector('.frail__track');
    var real = [].slice.call(rail.querySelectorAll('.fcard'));
    var n = real.length;
    if (!n) return;
    function phone() { return false; } /* back to auto-rotating on phone too, like before the static-grid pass */
    function cloneOnce() {
      real.forEach(function (c) {
        var copy = c.cloneNode(true);
        /* a repeated card is shown as it is: its photo never waits for a reveal that will not come */
        [].slice.call(copy.querySelectorAll('.rv')).concat(copy.classList.contains('rv') ? [copy] : []).forEach(function (e) { e.classList.add('in', 'settled'); });
        copy.classList.remove('lead');
        copy.setAttribute('data-clone', '1');
        copy.setAttribute('tabindex', '-1');
        copy.setAttribute('aria-hidden', 'true');
        track.appendChild(copy);
      });
    }
    /* the endless-loop illusion is desktop-only; on mobile the grid shows the real N cards once, no duplicates */
    if (!phone() && n > 1) cloneOnce();
    var cards = [].slice.call(track.querySelectorAll('.fcard'));
    var prev = section.querySelector('[data-mg-fprev]');
    var next = section.querySelector('[data-mg-fnext]');
    var pos = 0, busy = false, paused = true, until = 0;
    function hold(ms) { until = Date.now() + ms; }
    function step() {
      var narrow = 0;
      cards.forEach(function (c) { if (!c.classList.contains('lead')) narrow = c.getBoundingClientRect().width; });
      return narrow + 1;
    }
    function place(p, animate) {
      if (!animate) rail.classList.add('no-anim');
      cards.forEach(function (c, i) { c.classList.toggle('lead', i === ((p % cards.length) + cards.length) % cards.length); });
      track.style.transform = 'translate3d(' + (-p * step()) + 'px,0,0)';
      if (!animate) { void track.offsetWidth; rail.classList.remove('no-anim'); }
    }
    function go(dir, slow) {
      if (phone() || busy) return;
      busy = true;
      rail.classList.toggle('slow', !!slow);
      if (dir < 0 && pos === 0) { pos = n; place(pos, false); }
      pos += dir;
      place(pos, true);
      setTimeout(function () {
        if (pos >= n) { pos -= n; place(pos, false); }
        rail.classList.remove('slow');
        busy = false;
      }, slow ? 1960 : 760);
    }
    if (prev) prev.addEventListener('click', function () { hold(9000); go(-1); });
    if (next) next.addEventListener('click', function () { hold(9000); go(1); });
    rail.addEventListener('mouseenter', function () { hold(4000); });
    rail.addEventListener('mousemove', function () { hold(4000); });
    window.mgBindMobileSwipe(rail, function(dir){hold(9000);go(dir);}, function(){hold(9000);}, function(){hold(9000);});
    rail.addEventListener('scroll', function () {
      if (!phone()) return;
      var h = rail.scrollWidth / 2;
      if (rail.scrollLeft >= h) rail.scrollLeft -= h;
      else if (rail.scrollLeft <= 0) rail.scrollLeft += h;
    }, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        en.forEach(function (e) { paused = !e.isIntersecting; });
      }, { threshold: 0.35 }).observe(rail);
    } else { paused = false; }
    if (!reduce) {
      setInterval(function () {
        if (paused || busy || document.hidden || Date.now() < until || phone()) return;
        go(1, true);
      }, 3800);
    }
    var carouselViewportWidth = window.innerWidth;
    addEventListener('resize', function () {
      if (window.innerWidth === carouselViewportWidth) return;
      carouselViewportWidth = window.innerWidth;
      if (phone()) {
        track.querySelectorAll('.fcard[data-clone="1"]').forEach(function (c) { c.remove(); });
        real.forEach(function (c) { track.appendChild(c); });
        track.style.transform = '';
      } else {
        if (!track.querySelector('.fcard[data-clone="1"]') && n > 1) cloneOnce();
        cards = [].slice.call(track.querySelectorAll('.fcard'));
        place(pos, false);
      }
    });
    place(0, false);
  }
  function init(root) { [].slice.call((root || document).querySelectorAll('[data-mg-frail]')).forEach(build); }
  if (document.readyState === 'loading') addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ---- Memorigin collections: a family opens in place, and the thumbnails lead on a phone ---- */
(function () {
  function build(row) {
    if (row.getAttribute('data-mg-built')) return;
    row.setAttribute('data-mg-built', '1');
    var cols = [].slice.call(row.querySelectorAll('.famcol'));
    var tabs = [].slice.call(row.querySelectorAll('.fam__t'));
    var strip = row.querySelector('.fam__rail');
    if (!cols.length) return;
    var touched = false;
    function pick(i) {
      cols.forEach(function (c, k) { c.classList.toggle('is-on', k === i); });
      tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      if (strip && tabs[i] && getComputedStyle(strip).display !== 'none' && tabs[i].scrollIntoView) {
        try { strip.scrollTo({ left: tabs[i].offsetLeft - strip.offsetLeft - (strip.clientWidth - tabs[i].offsetWidth) / 2, behavior: 'smooth' }); } catch (e) {}
      }
    }
    cols.forEach(function (c, i) {
      c.addEventListener('click', function () {
        touched = true;
        /* an open family is a link; a closed one opens first */
        if (c.classList.contains('is-on')) {
          var url = c.getAttribute('data-url');
          if (url && url !== '#') window.location.href = url;
          return;
        }
        pick(i);
      });
    });
    tabs.forEach(function (t, i) { t.addEventListener('click', function () { touched = true; pick(i); }); });
    /* the row changes only on a click: first click opens a column, a second click on it goes to the watch */
    function fit() {
      var phone = innerWidth <= 820, open = row.querySelector('.famcol.is-on');
      if (phone && !open) pick(0);
      if (!phone && open && !touched) cols.forEach(function (c) { c.classList.remove('is-on'); });
    }
    fit();
    addEventListener('resize', fit);
  }
  function init(root) { [].slice.call((root || document).querySelectorAll('[data-mg-fam]')).forEach(build); }
  if (document.readyState === 'loading') addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ---- header: search is an icon until it is asked for ---- */
(function () {
  function init() {
    var head = document.querySelector('.site-header');
    if (!head) return;
    [].slice.call(head.querySelectorAll('.search-bar')).forEach(function (form) {
      if (form.getAttribute('data-mg-search')) return;
      form.setAttribute('data-mg-search', '1');
      var btn = form.querySelector('.search-bar--submit');
      var field = form.querySelector('input[type="search"]');
      if (!btn || !field) return;
      btn.addEventListener('click', function (e) {
        if (form.classList.contains('mg-open')) return;   /* second press submits */
        e.preventDefault();
        form.classList.add('mg-open');
        field.focus();
      });
      field.addEventListener('blur', function () {
        if (!field.value) form.classList.remove('mg-open');
      });
    });
  }
  if (document.readyState === 'loading') addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ---- Memorigin press: the big photo follows the small ones; each release shown once, then a fade back to the first ---- */
(function () {
  function build(section) {
    if (section.getAttribute('data-mg-built')) return;
    section.setAttribute('data-mg-built', '1');
    var wrap = section.querySelector('.press');
    var track = section.querySelector('.press__track');
    if (!wrap || !track) return;
    var clip = track.parentElement;
    var bigs = [].slice.call(section.querySelectorAll('.press__big'));
    var items = [].slice.call(section.querySelectorAll('.press__item'));
    var thumbs = [].slice.call(track.querySelectorAll('.press__thumb'));
    var n = thumbs.length;
    if (!n) return;
    var prev = section.querySelector('[data-mg-pprev]');
    var next = section.querySelector('[data-mg-pnext]');
    var noEl = section.querySelector('[data-mg-gno]'), bar = section.querySelector('[data-mg-gbar]');
    var pos = 0, busy = false;
    function phone() { return false; } /* back to auto-rotating on phone too, like before the static-grid pass */
    function step() { var t = thumbs[0]; return t ? t.getBoundingClientRect().width : 0; }
    function show(k) {
      bigs.forEach(function (b) { b.classList.toggle('is-on', +b.getAttribute('data-i') === k); });
      items.forEach(function (it) { it.classList.toggle('is-on', +it.getAttribute('data-i') === k); });
      thumbs.forEach(function (th, i) { th.classList.toggle('is-on', i === k); });
      if (noEl) noEl.textContent = (k < 9 ? '0' : '') + (k + 1);
      if (bar) bar.style.width = ((k + 1) / n * 100) + '%';
      if (prev) prev.disabled = false;
    }
    function place(p, animate) {
      /* circular strip: the small photos always start with the next release; after the last comes the first.
         On mobile the thumbnails sit in a fixed grid instead, so they never get reshuffled. */
      if (!phone()) { for (var i = 1; i <= n; i++) track.appendChild(thumbs[(p + i) % n]); }
      thumbs[p].style.display = phone() ? '' : 'none';
      thumbs.forEach(function (th, i) { if (i !== p) th.style.display = ''; });
      track.style.transform = '';
      if (phone()) clip.scrollLeft = 0;
    }
    function go(dir) {
      if (busy || n < 2) return;
      busy = true;
      pos = (pos + dir + n) % n;
      show(pos);
      place(pos, true);
      setTimeout(function () { busy = false; }, 500);
    }
    thumbs.forEach(function (th, i) {
      th.addEventListener('click', function () { pos = i; show(pos); place(pos, true); restartAuto(); });
    });
    if (prev) prev.addEventListener('click', function () { go(-1); restartAuto(); });
    if (next) next.addEventListener('click', function () { go(1); restartAuto(); });
    clip.addEventListener('scroll', function () {
      if (!phone() || busy) return;
      var i = Math.max(0, Math.min(n - 1, Math.round(clip.scrollLeft / (step() || 1))));
      if (i !== pos) { pos = i; show(i); }
    }, { passive: true });
    /* moves on by itself every seven seconds on desktop only */
    var autoT = null;
    function restartAuto() { clearInterval(autoT); if (!phone()) { autoT = setInterval(function () { if (!document.hidden && n > 1) go(1); }, 7000); } }
    window.mgBindMobileSwipe(wrap, function(dir){go(dir);}, function(){clearInterval(autoT);}, restartAuto);
    restartAuto();
    addEventListener('resize', function () { place(pos, false); });
    show(0); place(0, false);
  }
  function init(root) { [].slice.call((root || document).querySelectorAll('[data-mg-press]')).forEach(build); }
  if (document.readyState === 'loading') addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ---- hub pages: the card rail. Same as the homepage rows: big card on the left, the row slides along,
   the card that leaves on the left rejoins at the end (no copies), and a counter with a progress bar ---- */
(function () {
  function pad(i) { return (i < 9 ? '0' : '') + (i + 1); }
  function build(rail) {
    if (rail.getAttribute('data-mg-built')) return;
    rail.setAttribute('data-mg-built', '1');
    var track = rail.querySelector('.rail__track');
    var cards = [].slice.call(rail.querySelectorAll('.card'));
    var n = cards.length;
    if (!track || !n) return;
    var head = rail.previousElementSibling;
    var prev = head && head.querySelector('[data-mg-hprev]');
    var next = head && head.querySelector('[data-mg-hnext]');
    /* a short row stays a short row: no arrows, nothing moves */
    var used = 0;
    cards.forEach(function (c) { used += c.getBoundingClientRect().width + 1; });
    if (n < 3 && used <= rail.getBoundingClientRect().width + 2) {
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
      return;
    }
    cards.forEach(function (c, i) { c.setAttribute('data-k', i); });
    
    /* Seamless repeat: duplicate cards on desktop so the row has at least 12 cards and never shows empty space */
    if (!phone() && n > 1) {
      while (track.querySelectorAll('.card').length < 12) {
        cards.forEach(function (c, i) {
          var copy = c.cloneNode(true);
          copy.setAttribute('data-k', i);
          copy.setAttribute('data-clone', '1');
          copy.setAttribute('tabindex', '-1');
          copy.setAttribute('aria-hidden', 'true');
          copy.classList.remove('lead');
          var img = copy.querySelector('img');
          if (img) img.setAttribute('loading', 'lazy');
          track.appendChild(copy);
        });
      }
    }
    /* the counter: a progress bar, then 01 / 14 — the total is counted from the cards */
    var noEl = null, bar = null, arrows = prev && prev.parentElement;
    if (arrows && !arrows.querySelector('.glide__count')) {
      var cnt = document.createElement('span');
      cnt.className = 'glide__count'; cnt.setAttribute('aria-hidden', 'true');
      cnt.innerHTML = '<i class="glide__bar"><i></i></i><span class="glide__num"><b></b> / ' + pad(n - 1) + '</span>';
      arrows.insertBefore(cnt, arrows.firstChild);
      noEl = cnt.querySelector('b'); bar = cnt.querySelector('.glide__bar i');
    }
    var busy = false;
    function phone() { return false; } /* back to auto-rotating on phone too, like before the static-grid pass */
    function first() { return track.querySelector('.card'); }
    function count(c) {
      var i = c ? +c.getAttribute('data-k') : 0;
      if (phone()) {
        var w = cards[0].getBoundingClientRect().width || 1;
        i = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4 ? n - 1 : Math.round(rail.scrollLeft / w);
        i = Math.max(0, Math.min(n - 1, i));
      }
      if (noEl) noEl.textContent = pad(i);
      if (bar) bar.style.width = ((i + 1) / n * 100) + '%';
    }
    function narrow() {
      var w = 0;
      [].forEach.call(track.children, function (c) { if (!c.classList.contains('lead')) w = c.getBoundingClientRect().width; });
      return w + 1;
    }
    function lead(c) { [].forEach.call(track.children, function (x) { x.classList.toggle('lead', x === c && !phone()); }); }
    function still(fn) { rail.classList.add('no-anim'); fn(); void track.offsetWidth; rail.classList.remove('no-anim'); }
    function go(dir) {
      if (busy) return;
      if (phone()) {
        var cw = cards[0].getBoundingClientRect().width;
        if (dir > 0 && rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4) rail.scrollTo({ left: 0, behavior: 'smooth' });
        else rail.scrollBy({ left: dir * cw, behavior: 'smooth' });
        return;
      }
      busy = true;
      if (dir > 0) {
        var w = narrow(), out = first(), nx = out.nextElementSibling;
        lead(nx); count(nx);
        track.style.transform = 'translate3d(' + (-w) + 'px,0,0)';
        setTimeout(function () {
          still(function () { track.appendChild(out); track.style.transform = ''; });
          out.classList.add('is-back'); setTimeout(function () { out.classList.remove('is-back'); }, 20);
          busy = false;
        }, 980);
      } else {
        var last = track.lastElementChild;
        still(function () { track.insertBefore(last, first()); track.style.transform = 'translate3d(' + (-narrow()) + 'px,0,0)'; });
        requestAnimationFrame(function () {
          lead(last); count(last);
          track.style.transform = '';
          setTimeout(function () { busy = false; }, 980);
        });
      }
    }
    var autoT = null;
    function restartAuto() { clearInterval(autoT); if (!phone()) { autoT = setInterval(function () { if (!document.hidden) go(1); }, 7000); } }
    if (prev) prev.addEventListener('click', function () { go(-1); restartAuto(); });
    if (next) next.addEventListener('click', function () { go(1); restartAuto(); });
    window.mgBindMobileSwipe(rail, function(dir){go(dir);}, function(){clearInterval(autoT);}, restartAuto);
    restartAuto();
    rail.addEventListener('scroll', function () { if (phone()) count(); }, { passive: true });
    var carouselViewportWidth = window.innerWidth;
    addEventListener('resize', function () {
      if (window.innerWidth === carouselViewportWidth) return;
      carouselViewportWidth = window.innerWidth;
      if (phone()) {
        track.querySelectorAll('.card[data-clone="1"]').forEach(function (c) { c.remove(); });
        cards.forEach(function (c) { track.appendChild(c); });
      } else if (n > 1) {
        while (track.querySelectorAll('.card').length < 12) {
          cards.forEach(function (c, i) {
            var copy = c.cloneNode(true);
            copy.setAttribute('data-k', i);
            copy.setAttribute('data-clone', '1');
            copy.setAttribute('tabindex', '-1');
            copy.setAttribute('aria-hidden', 'true');
            copy.classList.remove('lead');
            var img = copy.querySelector('img');
            if (img) img.setAttribute('loading', 'lazy');
            track.appendChild(copy);
          });
        }
      }
      still(function () { track.style.transform = ''; lead(phone() ? null : first()); }); count(first());
      restartAuto();
    });
    still(function () { lead(first()); }); count(first());
  }
  function init(root) { [].slice.call((root || document).querySelectorAll('[data-mg-hrail]')).forEach(build); }
  if (document.readyState === 'loading') addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ---- product page: the thumbnails change the big photo ---- */
(function () {
  function init(root) {
    [].slice.call((root || document).querySelectorAll('.pdp__media')).forEach(function (m) {
      if (m.getAttribute('data-mg-ready')) return;
      m.setAttribute('data-mg-ready', '1');
      var shots = [].slice.call(m.querySelectorAll('.pdp__shot'));
      var thumbs = [].slice.call(m.querySelectorAll('.pdp__thumb'));
      function show(i) {
        shots.forEach(function (s) { s.classList.toggle('is-on', s.getAttribute('data-i') === String(i)); });
        thumbs.forEach(function (t) { t.classList.toggle('is-on', t.getAttribute('data-i') === String(i)); });
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { show(t.getAttribute('data-i')); });
        t.addEventListener('mouseenter', function () { show(t.getAttribute('data-i')); });
      });
    });
  }
  if (document.readyState === 'loading') addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ---- the hero film fades over its own still, so nothing flashes ---- */
(function () {
  function init(root) {
    [].slice.call((root || document).querySelectorAll('.mgx-hero video')).forEach(function (v) {
      if (v.getAttribute('data-mg-ready')) return;
      v.setAttribute('data-mg-ready', '1');
      function on() { v.classList.add('is-playing'); }
      if (!v.paused && v.readyState > 2) on();
      v.addEventListener('playing', on);
      v.addEventListener('loadeddata', function () { if (!v.paused) on(); });
      /* if it never plays, show it anyway rather than leaving a blank frame */
      setTimeout(function () { if (v.readyState > 2) on(); }, 4000);
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }
  if (document.readyState === 'loading') addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

}

/* Robust Shopify preview_theme_id & preview cookie preservation across all internal navigations */
(function() {
  var match = window.location.search.match(/[?&](preview_theme_id=\d+)/);
  if (!match) return;
  var previewParam = match[1];

  function rewriteHref(href) {
    if (!href) return href;
    if (href.indexOf('preview_theme_id') !== -1 || href.charAt(0) === '#' || href.indexOf('javascript:') === 0 || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) {
      return href;
    }
    // Clean absolute memorigin.store links to internal
    if (href.indexOf('https://memorigin.store') === 0) {
      href = href.replace('https://memorigin.store', '');
    }
    if (href.charAt(0) !== '/' && href.indexOf('http') === 0) {
      return href; // external domain
    }
    var sep = href.indexOf('?') !== -1 ? '&' : '?';
    var hashIdx = href.indexOf('#');
    if (hashIdx !== -1) {
      return href.slice(0, hashIdx) + sep + previewParam + href.slice(hashIdx);
    }
    return href + sep + previewParam;
  }

  function fixAllLinks() {
    var links = document.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var raw = a.getAttribute('href');
      var updated = rewriteHref(raw);
      if (updated !== raw) {
        a.setAttribute('href', updated);
      }
    }
  }

  // Intercept click events immediately at document root so dynamic/injected links never escape preview
  document.addEventListener('click', function(e) {
    var target = e.target;
    while (target && target.tagName !== 'A') {
      target = target.parentElement;
    }
    if (target && target.tagName === 'A') {
      var href = target.getAttribute('href');
      var updated = rewriteHref(href);
      if (updated !== href) {
        target.setAttribute('href', updated);
      }
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixAllLinks);
  } else {
    fixAllLinks();
  }
  window.addEventListener('load', fixAllLinks);
  setTimeout(fixAllLinks, 500);
  setTimeout(fixAllLinks, 1500);
})();

/* Intercept and ensure preview_theme_id is appended before navigation happens */
(function() {
  function getPreviewId() {
    var m = window.location.search.match(/[?&]preview_theme_id=(\d+)/);
    if (m) return m[1];
    try { return sessionStorage.getItem('mg_preview_theme_id'); } catch(e) { return null; }
  }

  document.addEventListener('click', function(e) {
    var pId = getPreviewId();
    if (!pId) return;

    var target = e.target;
    while (target && target.tagName !== 'A') {
      target = target.parentElement;
    }
    if (target && target.tagName === 'A') {
      var href = target.getAttribute('href');
      if (!href || href.indexOf('preview_theme_id') !== -1 || href.charAt(0) === '#' || href.indexOf('javascript:') === 0 || href.indexOf('mailto:') === 0) {
        return;
      }
      if (href.indexOf('https://memorigin.store') === 0) {
        href = href.replace('https://memorigin.store', '');
      }
      if (href.charAt(0) === '/' || href.indexOf('memorigin.store') !== -1) {
        var sep = href.indexOf('?') !== -1 ? '&' : '?';
        var hashIdx = href.indexOf('#');
        var newHref = hashIdx !== -1 
          ? href.slice(0, hashIdx) + sep + 'preview_theme_id=' + pId + href.slice(hashIdx)
          : href + sep + 'preview_theme_id=' + pId;
        target.setAttribute('href', newHref);
      }
    }
  }, true);
})();

/* Smooth handling of hash targets on landing pages to prevent jumpy layout shifts */
(function() {
  if (window.location.hash) {
    var h = window.location.hash;
    window.addEventListener('load', function() {
      var id = h.slice(1);
      try { id = decodeURIComponent(id); } catch (error) { /* Keep malformed fragments literal. */ }
      var el = document.getElementById(id);
      if (el) {
        setTimeout(function() {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    });
  }
})();

(function(){
  // Keep the approved fixed caption geometry; only remeasure it when width changes.
  var geometry = new WeakMap();
  function fit(root, refreshText){
    var plans=[], heights=[];
    root.querySelectorAll('[data-mg-hrail],[data-mg-glide],[data-mg-frail]').forEach(function(rail){
      var track=rail.querySelector('.rail__track,.glide,.frail__track');if(!track)return;
      var cards=Array.from(track.children).filter(function(c){return c.matches('.card,.fcard')&&c.dataset.clone!=='1'});
      if(!cards.length)return;
      var width=rail.getBoundingClientRect().width, previous=geometry.get(rail);
      if(previous&&Math.abs(previous.width-width)<0.25&&previous.count===cards.length&&rail.hasAttribute('data-mg-caption-stable')){
        if(refreshText)heights.push({rail:rail,track:track});
        return;
      }
      plans.push({rail:rail,track:track,cards:cards,width:width,probes:[]});
    });
    // Batch writes across every rail, then reads across every rail.
    plans.forEach(function(p){
      p.rail.removeAttribute('data-mg-caption-stable');
      p.rail.style.minHeight='';p.track.style.minHeight='';
      var fragment=document.createDocumentFragment();
      function probe(card,lead){
        var copy=card.cloneNode(true);copy.classList.toggle('lead',lead);copy.removeAttribute('id');
        copy.querySelectorAll('[id]').forEach(function(el){el.removeAttribute('id')});
        copy.setAttribute('aria-hidden','true');copy.inert=true;
        copy.style.cssText='position:relative;visibility:hidden;pointer-events:none;transition:none!important;';
        fragment.appendChild(copy);p.probes.push(copy);return copy;
      }
      p.narrow=probe(p.cards[0],false);p.cards.forEach(function(card){probe(card,true)});
      p.track.appendChild(fragment);
    });
    plans.forEach(function(p){
      p.captionWidth=p.narrow.clientWidth;p.photoHeight=0;
      p.probes.slice(1).forEach(function(copy){
        var pic=copy.querySelector('.pic,.fcard__pic');
        if(pic)p.photoHeight=Math.max(p.photoHeight,pic.getBoundingClientRect().height);
      });
    });
    plans.forEach(function(p){
      p.probes.forEach(function(copy){copy.remove()});
      if(!p.captionWidth||!p.photoHeight)return;
      p.rail.style.setProperty('--mg-caption-width',p.captionWidth+'px');
      p.rail.style.setProperty('--mg-photo-height',Math.ceil(p.photoHeight)+'px');
      p.rail.setAttribute('data-mg-caption-stable','');
      geometry.set(p.rail,{width:p.width,count:p.cards.length});heights.push(p);
    });
    // Font completion updates only the reserved row height, never caption widths/photos.
    heights.forEach(function(p){
      p.height=0;
      Array.from(p.track.children).forEach(function(card){
        if(card.matches('.card,.fcard'))p.height=Math.max(p.height,card.getBoundingClientRect().height);
      });
    });
    heights.forEach(function(p){
      if(p.height<=0)return;
      var value=String(Math.ceil(p.height)),size=value+'px';
      p.track.dataset.mgStableHeight=value;
      if(p.track.style.minHeight!==size)p.track.style.minHeight=size;
      if(!p.rail.matches('[data-mg-glide]')&&p.rail.style.minHeight!==size)p.rail.style.minHeight=size;
    });
  }
  function run(){fit(document,false)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  document.fonts?.ready.then(function(){fit(document,true)});
  var timer,viewportWidth=window.innerWidth;
  addEventListener('resize',function(){
    if(window.innerWidth===viewportWidth)return;
    viewportWidth=window.innerWidth;clearTimeout(timer);timer=setTimeout(run,180);
  });
  document.addEventListener('shopify:section:load',function(e){fit(e.target,true)});
})();


(function(){
  function labelControls(root){
    (root||document).querySelectorAll('.mgx button.arw[aria-label]').forEach(function(button){
      var previous=Array.from(button.attributes).some(function(attribute){return /prev$/.test(attribute.name);});
      var symbol=previous?'<':'>';
      if(button.textContent.trim()!==symbol)button.textContent=symbol;
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){labelControls(document)});else labelControls(document);
  document.addEventListener('shopify:section:load',function(event){labelControls(event.target)});
})();